import { GetBrokerPatientsTemplate, SubmitBrokerPatientsRequests } from '@/api/endpoints/Broker/BrokerPatient'
import { usePost } from '@/api/hooks'
import ActionBtn from '@/components/ActionBtn'
import ScreenHeader from '@/components/ScreenHeader'
import React, { useState } from 'react'

const TableHeader = ({ refModal, selectedItems }) => {

    const [isLoading, setIsLoading] = useState(false)

    const { onPost, isLoading: isLoadingPost } = usePost(SubmitBrokerPatientsRequests)



    const handleUpload = () => refModal?.current?.click()

    const downloadTemplate = () => {
        setIsLoading(true)
        GetBrokerPatientsTemplate().then(_ => { }).finally(() => setIsLoading(false))
    }

    const handleSubmit = () => {
        const body = {
            brokerPatientIds: selectedItems.map(item => item.brokerPatientId)
        }
        onPost(body)
    }


    return (
        <ScreenHeader title="Patients List Groups" >
            <div className='actions-container'>
                <ActionBtn className='broker-actions download-template' title="download-template" icon={isLoading ? "eos-icons:loading" : "material-symbols-light:download-rounded"} onApply={downloadTemplate} isDisabled={isLoading} />
                <ActionBtn className='broker-actions submit' title="ask-for-quotation" icon={isLoadingPost ? "eos-icons:loading" : "prime:send"} onApply={handleSubmit} isDisabled={isLoadingPost} />
            </div>
        </ScreenHeader>
    )
}

export default TableHeader